"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EventName = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _affiliateActions = require("../actions/affiliate-actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var EventName = {
  LOAD_PAGE: 'LOAD_PAGE',
  SET_AFFILIATE: 'SET_AFFILIATE',
  REGISTER: 'REGISTER',
  CREATE_APPLICATION: 'CREATE_APPLICATION',
  PRODUCT_SELECT: 'PRODUCT_SELECT',
  COMPLETE: 'COMPLETE'
};
exports.EventName = EventName;
var allowed = ['eventName', 'identityUuid', 'affiliateId', 'affiliateType', 'affiliateRawData', 'applicationUuid', 'applicationType', 'platformType'];
var required = ['eventName', 'userAgent', 'platformType'];
var gaTries = 0;

var fakeGa = function fakeGa(callback) {
  return callback({
    get: function get() {
      return '00000000.0000000000';
    }
  });
};

function checkGa(onGa) {
  var gaExists = typeof ga === 'function' && ga.length > 0; // privacy blockers may overwrite ga function with a noop

  if (gaExists || gaTries > 10) {
    onGa(gaExists ? ga : fakeGa);
  } else {
    gaTries++;
    window.setTimeout(function () {
      return checkGa(onGa);
    }, 100);
  }
} // In a component, set `window.userDataLayer = new UserDataLayer(dispatch, platformType?)`, then use
// it via `window.userDataLayer.push({ data })`.


var UserDataLayer = /*#__PURE__*/function () {
  function UserDataLayer(dispatch, propertyId) {
    var platformType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'WEB';
    (0, _classCallCheck2.default)(this, UserDataLayer);
    if (!dispatch || !propertyId) throw Error('Dispatch and property id required');
    this.dispatch = dispatch;
    this.propertyId = propertyId;
    this.data = {
      userAgent: navigator.userAgent,
      platformType: platformType
    }; // Start the websocket connection

    dispatch((0, _affiliateActions.initWebsocket)());
  }

  (0, _createClass2.default)(UserDataLayer, [{
    key: "push",
    value: function push(newData) {
      var _this = this;

      var useHttp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new Promise(function (resolve, reject) {
        var dispatch = _this.dispatch,
            propertyId = _this.propertyId;
        var filteredData = Object.keys(newData).filter(function (key) {
          return allowed.includes(key) && typeof newData[key] === 'string';
        }).reduce(function (acc, key) {
          return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, key, newData[key]));
        }, {}); // Reconstruct and clean data

        var dataCopy = _objectSpread(_objectSpread({}, _this.data), filteredData);

        Object.keys(dataCopy).forEach(function (key) {
          return (dataCopy[key] === null || dataCopy[key] === '') && delete dataCopy[key];
        });
        _this.data = _objectSpread({}, dataCopy); // Only on a push with an eventName do we trigger a message

        if (!filteredData.eventName) {
          resolve();
        } else if (!UserDataLayer.validateData(_this.data)) {
          reject({
            message: 'Data layer incomplete, cannot send event'
          });
        } else {
          var dispatchEvent = function dispatchEvent(localGa) {
            return localGa(function (tracker) {
              if (tracker) {
                var payload = UserDataLayer.toPayload(_objectSpread(_objectSpread({}, dataCopy), {}, {
                  googleAnalyticsClientId: tracker.get('clientId')
                }));
                resolve(dispatch(useHttp ? (0, _affiliateActions.saveUserEvent)(payload) : (0, _affiliateActions.saveSocketUserEvent)({
                  type: _affiliateActions.SOCKET_CONNECT,
                  data: payload
                })));
              } else {
                ga('create', propertyId, 'auto');
                dispatchEvent(localGa);
              }
            });
          };

          checkGa(dispatchEvent);
        }
      });
    }
  }], [{
    key: "toPayload",
    value: function toPayload(data) {
      var affiliate = data.affiliateId && data.affiliateType ? {
        affiliateId: data.affiliateId,
        type: data.affiliateType,
        rawData: data.affiliateRawData || null
      } : null;
      var applicationInfo = data.applicationUuid && data.applicationType ? {
        applicationUuid: data.applicationUuid,
        type: data.applicationType
      } : null;
      return {
        eventName: data.eventName,
        googleAnalyticsClientId: data.googleAnalyticsClientId,
        systemInfo: {
          userAgent: data.userAgent,
          platformType: data.platformType
        },
        identityUuid: data.identityUuid || null,
        affiliate: affiliate,
        applicationInfo: applicationInfo
      };
    }
  }, {
    key: "validateData",
    value: function validateData(data) {
      var dataKeys = Object.keys(data);
      return required.every(function (r) {
        return dataKeys.includes(r);
      }) && (!data.affiliateId && !data.affiliateType || data.affiliateId && data.affiliateType) && (!data.applicationUuid && !data.applicationType || data.applicationUuid && data.applicationType);
    }
  }]);
  return UserDataLayer;
}();

var _default = UserDataLayer;
exports.default = _default;